import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import createLogger from 'redux-logger';
import createMiddleware from '../redux/clientMiddleware';
import auth from '../middleware/auth';
import ApiClient from '../ApiClient';
import mySaga from '../sagas';
import { browserHistory } from 'react-router';
// import Api from '../api';
import { createRootReducer } from '../reducers/root';

const client = new ApiClient();
// const api = new Api(client);

export default function configureStore(initialState, apolloClient) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    createRootReducer(apolloClient),
    initialState,
    compose(
      applyMiddleware(
        createMiddleware(client),
        auth,
        routerMiddleware(browserHistory),
        sagaMiddleware,
        createLogger({
          collapsed: true,
        }),
      ),
    ),
  );

  sagaMiddleware.run(mySaga, store.dispatch);

  if (module.hot) {
    module.hot.accept('../reducers/root', what => {
      const nextRootReducer = require('../reducers/root').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js